/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

import { getDetectionStatusUpdate, detectionIsOn } from '@trqk/utils';

import { DetectionStatusMeter } from '../..';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Displays a DetectionStatusMeter for a given DetectionStatusChange[], typically from
 * `trqkSong.detection_history`.
 * @param Props must contain a `cell.value` which is a DetectionStatusChange[]
 */
export function DetectionStatusMeterCell<D extends object>({
    cell,
}: Props<D>): JSX.Element | string {
    const detectionHistory: DetectionStatusChange[] | null = cell.value;
    const statusUpdate = getDetectionStatusUpdate({ detectionHistory });

    return (
        <DetectionStatusMeter
            detectionHistory={
                detectionHistory ?? ([] as DetectionStatusChange[])
            }
            grayscale={!detectionIsOn(statusUpdate?.status ?? null)}
        />
    );
}
